import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../components/ui/tooltip';

const LabelTooltip = ({Icon, content, variant=""}) => {
    let size;
    if(variant === "sm") size = "4";
    else if(variant === "lg") size = "7";
    else if(variant === "xl") size = "9";
    else size = "5";
    return (
        <>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger>
                        <Icon className={`h-${size} w-${size} mb-[-3px] ml-[5px] text-primary`}/>
                    </TooltipTrigger>
                    <TooltipContent side="right" className="flex bg-primary items-center gap-4 mb-10">
                        {content}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </>
    );
};

export default LabelTooltip;